import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=f37b8120&scoped=true&"
import script from "./GroupInfo.vue?vue&type=script&lang=js&"
export * from "./GroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./GroupInfo.vue?vue&type=style&index=0&id=f37b8120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b8120",
  null
  
)

export default component.exports